import { MplProgress } from './MplProgress';

export interface IMplStepProgressProps {
	/* Current step (e.g., 1, 2, 3) */
	value: number;
	/* Total number of steps (e.g., 5) */
	maxSteps: number;
}

export function MplStepProgress({ value, maxSteps }: IMplStepProgressProps) {
	const clampedValue = Math.min(Math.max(value, 0), maxSteps);
	const percentage = maxSteps > 0 ? (clampedValue / maxSteps) * 100 : 0;
	return <MplProgress value={percentage} />;
}
